import React from 'react';
import './OfferUnlockSuccess.scss';

const getTryredirectUrl = (AR, enable_3D, cat_PLP_url, cat_ar_url) => {
  let landingUrl;
  if (enable_3D === 'ON') {
    if (AR === 'ON') {
      landingUrl = cat_ar_url;
    } else {
      landingUrl = '/frame-size?iplOffer';
    }
  } else if (AR === 'ON') {
    landingUrl = cat_ar_url;
  } else {
    landingUrl = cat_PLP_url;
  }
  return landingUrl;
};

function OfferUnlockSuccess(props) {
  const {
    successConfig,
    selectedOffer,
    isDesktop,
    offerConfig,
    isPdpFlow,
    offerItem,
    isDesktopPdp,
  } = props;
  const { unlock_text } = successConfig || {}; // try_glassess_text, camera_permission_text
  const { offer_text } = selectedOffer || {};
  // Offer Config
  const { AR, enable_3D } = offerConfig || {};
  const { cat_PLP_url, cat_ar_url } = selectedOffer || {};
  const { pdpUrl, offerLabel } = offerItem || {};
  const pdfRedirectUrl = pdpUrl ? `${pdpUrl}?redirectFromOfferFlow=1` : null;
  const tryGlassessUrl = isPdpFlow
    ? pdfRedirectUrl
    : getTryredirectUrl(AR, enable_3D, cat_PLP_url, cat_ar_url);

  const getButtonTitle = () => {
    const {
      isPdpFlow,
      isDesktopPdp,
      dataLocale: { BUY_NOW, CONTINUE },
      successConfig,
    } = props;
    const { try_glassess_cta } = successConfig || {};
    let title = '';
    if (isDesktopPdp) {
      title = CONTINUE;
    } else if (isPdpFlow) {
      title = BUY_NOW;
    } else {
      title = try_glassess_cta;
    }
    return title;
  };

  return (
    <React.Fragment>
      <div className={`offer-unlock-success ${isDesktop ? 'padding-b25' : ''}`}>
        <div>
          <img
            alt={unlock_text}
            src={
              isDesktop
                ? 'https://static1.lenskart.com/media/desktop/img/ezgif-com-crop.gif'
                : 'https://static.lenskart.com/media/mobile/images/offer/unlock-success.gif'
            }
          />
        </div>
        {unlock_text && (
          <div
            className={`text-topaz fsp20 fs20 fw500 mr-b20 ${
              isDesktop ? 'padding-t15 padding-b15' : ''
            }`}
          >
            {unlock_text}
          </div>
        )}
        {Boolean(offer_text || offerLabel) && (
          <div className="pd-l20 pd-r20">
            <div className="offer-text fw500 lh-34 text-center text-color_3c fsp16 fs16 bora-4">
              {offerLabel || offer_text}
            </div>
          </div>
        )}
        <div
          className={`${
            isDesktop ? 'bottom-container-desktop' : 'pos-fix bottom-container-mobile'
          } pd-l12 pd-r12 text-center`}
        >
          {/* {try_glassess_text && !offerLabel && <div className="bottom-text text-color_3c fsp16 fs16 fw500">{try_glassess_text}</div>} */}
          {/* {camera_permission_text && !offerLabel && <div className={`${isDesktop ? 'camera-permission-text' : ''} bottom-note text-color_light_3c fsp14 fs14 lh-30 color_pale_black`}>{camera_permission_text}</div>} */}
          <a
            className={`submit-offer fsp18 fs18 fw500 text-uppercase display-center-justify mr-t30 bora-4 ${
              isDesktop ? 'btn-padding' : ''
            }`}
            href=""
            onClick={e => {
              e.preventDefault();
              if (isDesktopPdp) {
                props.changeIsContinueClickedInOfferModalSuccess(true);
              } else {
                window.location.href = tryGlassessUrl || cat_PLP_url;
              }
            }}
          >
            {getButtonTitle()}
          </a>
        </div>
      </div>
    </React.Fragment>
  );
}

export default OfferUnlockSuccess;
